import React from 'react';

import './ProductHeader.css';

interface ProductHeaderProps {
    brand: string | null;
    name: string;
    price: string | null;
}

export function ProductHeader({ brand, name, price }: ProductHeaderProps) {
    return (
        <header className="pdp-header">
            <div className="pdp-header__name">
                {brand && <p className="pdp-header__brand">{brand}</p>}
                <h1 className="pdp-header__title">{name}</h1>
            </div>
            <div className="pdp-header__price-row">
                <div className="pdp-header__price-col">
                    {price && <p className="pdp-header__price">{price}</p>}
                    <p className="pdp-header__disclaimer">products may generate commissions</p>
                </div>
            </div>
        </header>
    );
}
